import { post, URL } from 'utils';
import { fetch } from './fetch';

export const PM_CREATE = 'PM.PM_CREATE';

export const createPM = (member_id, msgs) => (dispatch, getState) => {
  // const state = getState();
  // const conv_id = state.conv.list.find(obj => obj.id === [user_id, state.user.id].sort().join());
  // if (conv_id) {
  //   actions.selectPM();
  //   actions.selectConv(conv_id);
  // } else {
  //   const request = { url: URL.PM.CREATE + user_id, method: post };
  //   fetch(request, PM_CREATE);
  // }
  const request = { url: URL.PM.CREATE + member_id, params: { msgs }, method: post };
  fetch(request, PM_CREATE);
};



// WEBPACK FOOTER //
// ./src/actions/pm.js